import { s as r } from "../../../../../../../_virtual/index3.js";
function s() {
  return r.useSyncExternalStore(
    e,
    () => !0,
    () => !1
  );
}
function e() {
  return () => {
  };
}
export {
  s as useIsHydrated
};
